import React, {
  useRef,
  useState
} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { 
  User as UserIcon,
  LogOut as LogOutIcon
} from 'react-feather';


import { logout } from 'src/actions/accountActions';
import AvatarImage from 'src/components/AvatarImage';

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

function Account() {
  const classes = useStyles();
  const history = useNavigate();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await dispatch(logout());
      history('/');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        {/* <Avatar
          alt="User"
          className={classes.avatar}
          src={account.user.avatar}
        /> */}
        <AvatarImage 
          // alt="User"
          className={classes.avatar}
          // src={account.user.avatar}
          id={account.user.id}
        />
        <Hidden smDown>
          <Typography
            variant="h6"
            color="inherit"
          >
            {`${account.user.firstName} ${account.user.lastName}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        //getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >        
        <MenuItem
          component={RouterLink}
          to="/app/account"          
        >
           <ListItemIcon>
            <UserIcon fontSize="small" />
          </ListItemIcon>
          Användarkonto
        </MenuItem>
        <MenuItem onClick={handleLogout}>
        <ListItemIcon>
            <LogOutIcon fontSize="small" />
          </ListItemIcon>
          Logga ut
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
